export default __webpack_public_path__ + "static/primeVideo-4a630401c5af0f88e827cba04fa9b136.jpg";